import { Box, Button, Grid, IconButton, Paper, TextField, Tooltip, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import PIS, { API_URL } from '../../../api/api';
import AddAlertMessage from '../../../components/alert/Alert';
import CustomSelect from '../../../components/custom-select/CustomSelect';
import { DEFAULT_ROW_SIZE, ERROR, GENDER_OPTIONS, SOMETHING_WENT_WRONG, SUCCESS } from '../../../utils/constants';
import { EMPLOYEE_TYPE } from '../../../utils/constants/forms';
import { DateUtils } from '../../../utils/dateUtils';
import DepartmentSelect from '../components/DepartmentSelect/DepartmentSelect';
import StaffsList from '../staffs/helpers/StaffsList';
import styles from './style';
import { CSVLink } from 'react-csv';
import { GetApp } from '@material-ui/icons';
import { AppUtils } from '../../../utils/appUtils';
import { AppMisc } from '../../../misc/appMisc';

export default function SearchStaff() {
  const { register, handleSubmit, setValue } = useForm();
  const [searchResult, setSearchResult] = useState(null);
  const [postOptions, setPostOptions] = useState([]);
  const [size, setSize] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [searchParam, setSearchParam] = useState('');
  const filter = AppUtils.getUrlParam("filter");
  const [rowSize, setRowSize] = useState(DEFAULT_ROW_SIZE);
  const classes = styles();
  const formerEmployee = AppUtils.getUrlParam("formerEmployee");

  useEffect(() => {
    getAllPostList()
  }, [])

  const getAllPostList = () => {
    PIS.get(API_URL.post)
      .then(response => {
        let jsondata = response.data;
        if (jsondata.type === SUCCESS) {
          setPostOptions((jsondata.data || []).map(item => {
            return { value: item.id, label: item.name }
          }));
        } else {
          AddAlertMessage({ type: jsondata.type, message: jsondata.message })
        }
      }).catch(error => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG })
      })
  }

  useEffect(() => {
    register({ name: "gender" });
    register({ name: "employeeType" });
    register({ name: "departmentId" });
  }, [register])

  function getGenderLabel(gender) {
    return gender ? GENDER_OPTIONS.find(obj => obj.value === gender).label : "-";
  }

  const onSubmit = data => {
    PIS.get(`${API_URL.staff}/search?fullNameInEnglish=${data.fullNameInEnglish}&fullNameInNepali=${data.fullNameInNepali}&gender=${data.gender}&employeeType=${data.employeeType}&departmentId=${data.departmentId}&staffCodeNumber=${data.staffCodeNumber}&workingWardNumber=${data.workingWardNumber}`)
      .then(response => {
        let jsondata = response.data;
        if (jsondata.type === SUCCESS) {
          for (let i = 0; i < jsondata.data.length; i++) {
            jsondata.data[i].personalInfo.gender = getGenderLabel(jsondata.data[i].personalInfo.gender);
            jsondata.data[i].personalInfo.dateOfBirth = jsondata.data[i].personalInfo.dateOfBirth !== 0 ? DateUtils.getDateFromMilliseconds(jsondata.data[i].personalInfo.dateOfBirth) : "-";
            jsondata.data[i].personalInfo.citizenshipNumber = jsondata.data[i].personalInfo.citizenshipNumber || "-";
            jsondata.data[i].personalInfo.nationalIdentityCardNumber = jsondata.data[i].personalInfo.nationalIdentityCardNumber || "-";
            jsondata.data[i].currentServiceInfo.decisionDate = jsondata.data[i].currentServiceInfo.decisionDate !== 0 ? DateUtils.getDateFromMilliseconds(jsondata.data[i].currentServiceInfo.decisionDate) : "-";
            jsondata.data[i].currentServiceInfo.officeAttendanceDate = jsondata.data[i].currentServiceInfo.officeAttendanceDate ? DateUtils.getDateFromMilliseconds(jsondata.data[i].currentServiceInfo.officeAttendanceDate) : "-";
            jsondata.data[i].appointedServiceInfo.decisionDate = jsondata.data[i].appointedServiceInfo.decisionDate !== 0 ? DateUtils.getDateFromMilliseconds(jsondata.data[i].appointedServiceInfo.decisionDate) : "-";
            jsondata.data[i].appointedServiceInfo.officeAttendanceDate = jsondata.data[i].appointedServiceInfo.officeAttendanceDate !== 0 ? DateUtils.getDateFromMilliseconds(jsondata.data[i].appointedServiceInfo.officeAttendanceDate) : "-";
            jsondata.data[i].retirementDetail.date = jsondata.data[i].retirementDetail.date ? DateUtils.getDateFromMilliseconds(jsondata.data[i].retirementDetail.date) : "-";
          }
          setSearchResult(jsondata.data || []);
        } else {
          AddAlertMessage({ type: jsondata.type, message: jsondata.message });
        }
      }).catch(error => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG })
      }
      )
  }

  const handleCustomSelectChange = (name, value) => {
    setValue(name, value);
  }

  const headers = [
    { label: "नाम", key: "personalInfo.fullNameInNepali" },
    { label: "लिङ्ग", key: "personalInfo.gender" },
    { label: "जन्म मिति (बि.सं.)", key: "personalInfo.dateOfBirth" },
    { label: "नागरिकता नं.", key: "personalInfo.citizenshipNumber" },
    { label: "राष्ट्रीय परिचय पत्र नं.", key: "personalInfo.nationalIdentityCardNumber" },
    { label: "पति/पत्नीको नाम", key: "familyInfo.husbandOrWifeNameInNepali" },
    { label: "पिताको नाम", key: "familyInfo.fatherNameInNepali" },
    { label: "आमाको नाम", key: "familyInfo.motherNameInNepali" },
    { label: "छोरी संख्या", key: "familyInfo.daughterCount" },
    { label: "छोरा संख्या", key: "familyInfo.sonCount" },
    { label: "प्रदेश", key: "addressDetail.permanentAddressProvince" },
    { label: "जिल्ला", key: "addressDetail.permanentAddressDistrict" },
    { label: "गाउँ/नगरपालिका", key: "addressDetail.permanentAddressPalikaName" },
    { label: "वडा नं.", key: "addressDetail.permanentAddressWardNumber" },
    { label: "गाँउ/टोल", key: "addressDetail.permanentAddressGaunOrTole" },
    { label: "घर नं", key: "addressDetail.permanentAddressHomeNumber" },
    { label: "टेलीफोन नं", key: "addressDetail.permanentAddressPhoneNumber" },
    { label: "अन्य संपर्क विवरण", key: "addressDetail.permanentAddressOthersContactDetail" },
    { label: "माथिल्लो निकाय (नियूक्ती सेवा)", key: "appointedServiceInfo.upperBody" },
    { label: "जिल्ला", key: "appointedServiceInfo.district" },
    { label: "कार्यालय", key: "appointedServiceInfo.office" },
    { label: "सेवा परिमाण", key: "appointedServiceInfo.serviceVolume" },
    { label: "सेवाको किसिम", key: "appointedServiceInfo.serviceType" },
    { label: "श्रेणी/तह", key: "appointedServiceInfo.categoryAndLabel" },
    { label: "पद", key: "appointedServiceInfo.post" },
    { label: "निर्णय मिति", key: "appointedServiceInfo.decisionDate" },
    { label: "कार्यालयमा हाजिरी मिति", key: "appointedServiceInfo.officeAttendanceDate" },
    { label: "माथिल्लो निकाय (हालको सेवा)", key: "currentServiceInfo.upperBody" },
    { label: "जिल्ला", key: "currentServiceInfo.district" },
    { label: "कार्यालय", key: "currentServiceInfo.office" },
    { label: "सेवा परिमाण", key: "currentServiceInfo.serviceVolume" },
    { label: "सेवाको किसिम", key: "currentServiceInfo.serviceType" },
    { label: "श्रेणी/तह", key: "currentServiceInfo.categoryAndLabel" },
    { label: "पद", key: "currentServiceInfo.post" },
    { label: "निर्णय मिति", key: "currentServiceInfo.decisionDate" },
    { label: "कार्यालयमा हाजिरी मिति", key: "currentServiceInfo.officeAttendanceDate" },
    { label: "अवकाशको स्थिति", key: "retirementDetail.status" },
    { label: "अवकाश", key: "retirementDetail.type" },
    { label: "अवकाशको मिति", key: "retirementDetail.date" },
    { label: "अनुमानित अवकाशको मिति", key: "retirementDetail.estimatedDate" },
    { label: "क.सं. कोष परिचय पत्र नं.", key: "othersInfo.citizenInvestmentFundNumber" },
    { label: "राहदानी नं:", key: "othersInfo.passportNumber" },
    { label: "सवारी चालक अनुमती नं.", key: "othersInfo.drivingLicenceNumber" },
    { label: "अशक्त विवरण", key: "othersInfo.differentlyAbledDescription" },
    { label: "मोबाईल नम्बर", key: "othersInfo.mobileNumber" }
  ]

  const getStaffs = () => {
    setIsLoading(true);
    let url = API_URL.staff + `?pageNumber=${pageNumber}&rowSize=${rowSize}`
    if (searchParam) {
      url += `&searchParam=${searchParam}`
    }
    if (filter) {
      url += `&filter=${filter}`
    }
    if (formerEmployee) {
      url += `&formerEmployee=${formerEmployee}`
    }
    PIS.get(url).then(response => {
      let jsondata = response.data;
      for (let i = 0; i < jsondata.objectList.length; i++) {
        jsondata.objectList[i].personalInfo.gender = getGenderLabel(jsondata.objectList[i].personalInfo.gender);
        jsondata.objectList[i].personalInfo.dateOfBirth = jsondata.objectList[i].personalInfo.dateOfBirth !== 0 ? DateUtils.getDateFromMilliseconds(jsondata.objectList[i].personalInfo.dateOfBirth) : "-";
        jsondata.objectList[i].personalInfo.citizenshipNumber = jsondata.objectList[i].personalInfo.citizenshipNumber || "-";
        jsondata.objectList[i].personalInfo.nationalIdentityCardNumber = jsondata.objectList[i].personalInfo.nationalIdentityCardNumber || "-";

        jsondata.objectList[i].familyInfo.husbandOrWifeNameInNepali = jsondata.objectList[i].familyInfo.husbandOrWifeNameInNepali || "-;"
        jsondata.objectList[i].familyInfo.fatherNameInNepali = jsondata.objectList[i].familyInfo.fatherNameInNepali || "-";
        jsondata.objectList[i].familyInfo.motherNameInNepali = jsondata.objectList[i].familyInfo.motherNameInNepali || "-";
        jsondata.objectList[i].familyInfo.daughterCount = jsondata.objectList[i].familyInfo.daughterCount || "-";
        jsondata.objectList[i].familyInfo.sonCount = jsondata.objectList[i].familyInfo.sonCount || "-";

        jsondata.objectList[i].addressDetail.permanentAddressProvince = AppMisc.getProvinceName(jsondata.objectList[i].addressDetail.permanentAddressProvince) || "-";
        jsondata.objectList[i].addressDetail.permanentAddressDistrict = AppMisc.getDistrictName(jsondata.objectList[i].addressDetail.permanentAddressDistrict) || "-";
        jsondata.objectList[i].addressDetail.permanentAddressPalikaName = AppMisc.getPalikaNameFromHost(jsondata.objectList[i].addressDetail.permanentAddressPalikaName) || "-";
        jsondata.objectList[i].addressDetail.permanentAddressWardNumber = jsondata.objectList[i].addressDetail.permanentAddressWardNumber || "-";
        jsondata.objectList[i].addressDetail.permanentAddressGaunOrTole = jsondata.objectList[i].addressDetail.permanentAddressGaunOrTole || "-";
        jsondata.objectList[i].addressDetail.permanentAddressHomeNumber = jsondata.objectList[i].addressDetail.permanentAddressHomeNumber || "-";
        jsondata.objectList[i].addressDetail.permanentAddressPhoneNumber = jsondata.objectList[i].addressDetail.permanentAddressPhoneNumber || "-";
        jsondata.objectList[i].addressDetail.permanentAddressOthersContactDetail = jsondata.objectList[i].addressDetail.permanentAddressOthersContactDetail || "-";

        jsondata.objectList[i].appointedServiceInfo.upperBody = jsondata.objectList[i].appointedServiceInfo.upperBody || "-";
        jsondata.objectList[i].appointedServiceInfo.district = jsondata.objectList[i].appointedServiceInfo.district || "-";
        jsondata.objectList[i].appointedServiceInfo.office = jsondata.objectList[i].appointedServiceInfo.office || "-";
        jsondata.objectList[i].appointedServiceInfo.serviceVolume = jsondata.objectList[i].appointedServiceInfo.serviceVolume || "-";
        jsondata.objectList[i].appointedServiceInfo.serviceType = jsondata.objectList[i].appointedServiceInfo.serviceType || "-";
        jsondata.objectList[i].appointedServiceInfo.categoryAndLabel = jsondata.objectList[i].appointedServiceInfo.categoryAndLabel || "-";
        jsondata.objectList[i].appointedServiceInfo.post = jsondata.objectList[i].appointedServiceInfo.post || "-";
        jsondata.objectList[i].appointedServiceInfo.decisionDate = jsondata.objectList[i].appointedServiceInfo.decisionDate !== 0 ? DateUtils.getDateFromMilliseconds(jsondata.objectList[i].appointedServiceInfo.decisionDate) : "-";
        jsondata.objectList[i].appointedServiceInfo.officeAttendanceDate = jsondata.objectList[i].appointedServiceInfo.officeAttendanceDate !== 0 ? DateUtils.getDateFromMilliseconds(jsondata.objectList[i].appointedServiceInfo.officeAttendanceDate) : "-";

        jsondata.objectList[i].currentServiceInfo.upperBody = jsondata.objectList[i].currentServiceInfo.upperBody || "-";
        jsondata.objectList[i].currentServiceInfo.district = jsondata.objectList[i].currentServiceInfo.district || "-";
        jsondata.objectList[i].currentServiceInfo.office = jsondata.objectList[i].currentServiceInfo.office || "-";
        jsondata.objectList[i].currentServiceInfo.serviceVolume = jsondata.objectList[i].currentServiceInfo.serviceVolume || "-";
        jsondata.objectList[i].currentServiceInfo.serviceType = jsondata.objectList[i].currentServiceInfo.serviceType || "-";
        jsondata.objectList[i].currentServiceInfo.categoryAndLabel = jsondata.objectList[i].currentServiceInfo.categoryAndLabel || "-";
        jsondata.objectList[i].currentServiceInfo.post = jsondata.objectList[i].currentServiceInfo.post || "-";
        jsondata.objectList[i].currentServiceInfo.decisionDate = jsondata.objectList[i].currentServiceInfo.decisionDate !== 0 ? DateUtils.getDateFromMilliseconds(jsondata.objectList[i].currentServiceInfo.decisionDate) : "-";
        jsondata.objectList[i].currentServiceInfo.officeAttendanceDate = jsondata.objectList[i].currentServiceInfo.officeAttendanceDate ? DateUtils.getDateFromMilliseconds(jsondata.objectList[i].currentServiceInfo.officeAttendanceDate) : "-";

        jsondata.objectList[i].retirementDetail.status = jsondata.objectList[i].retirementDetail.status || "-";
        jsondata.objectList[i].retirementDetail.type = jsondata.objectList[i].retirementDetail.type || "-";
        jsondata.objectList[i].retirementDetail.date = jsondata.objectList[i].retirementDetail.date ? DateUtils.getDateFromMilliseconds(jsondata.objectList[i].retirementDetail.date) : "-";
        jsondata.objectList[i].retirementDetail.estimatedDate = jsondata?.objectList[i]?.retirementDetail?.estimatedDate ? DateUtils.getDateFromMilliseconds(jsondata.objectList[i].retirementDetail.estimatedDate) : "-";
        jsondata.objectList[i].othersInfo.citizenInvestmentFundNumber = jsondata.objectList[i].othersInfo.citizenInvestmentFundNumber || "-";
        jsondata.objectList[i].othersInfo.passportNumber = jsondata.objectList[i].othersInfo.passportNumber || "-";
        jsondata.objectList[i].othersInfo.drivingLicenceNumber = jsondata.objectList[i].othersInfo.drivingLicenceNumber || "-";
        jsondata.objectList[i].othersInfo.differentlyAbledDescription = jsondata.objectList[i].othersInfo.differentlyAbledDescription || "-";
        jsondata.objectList[i].othersInfo.mobileNumber = jsondata.objectList[i].othersInfo.mobileNumber || "-";
        setSearchResult(jsondata.objectList);
        setSize(jsondata.size);
        setIsLoading(false);
      }
    }).catch(error => {
      AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      setIsLoading(false);
    });
  }

  useEffect(() => {
    if (pageNumber) {
      getStaffs();
    }
  }, [pageNumber, searchParam, rowSize]);

  return (
    <Box className={classes.root}>
      <Box className={classes.heading}>
        <Typography variant="h6">कर्मचारी खोज्नुहोस</Typography>
      </Box>
      <Paper className={classes.paper} elevation={0}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={2} alignItems="center" className={classes.row}>
            <Grid item xs={3}>
              <TextField
                label="पुरा नाम अङ्ग्रेजीमा"
                name="fullNameInEnglish"
                type="text"
                variant="outlined"
                size="small"
                inputRef={register}
                fullWidth
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                label="पुरा नाम नेपालीमा"
                name="fullNameInNepali"
                type="text"
                variant="outlined"
                size="small"
                inputRef={register}
                fullWidth
              />
            </Grid>
            <Grid item xs={3}>
              <CustomSelect
                label="लिङ्ग"
                name="gender"
                options={GENDER_OPTIONS}
                onChange={handleCustomSelectChange}
              />
            </Grid>
            <Grid item xs={3}>
              <CustomSelect
                label="Employee Type"
                name="employeeType"
                options={EMPLOYEE_TYPE}
                onChange={handleCustomSelectChange}
              />
            </Grid>
            <Grid item xs={3}>
              <DepartmentSelect
                onChange={handleCustomSelectChange}
                departmentId={"departmentId"}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                label="कर्मचारी संकेत नं."
                name="staffCodeNumber"
                type="text"
                variant="outlined"
                size="small"
                inputRef={register}
                fullWidth
              />
            </Grid>
            <Grid item xs={3}>
              <Tooltip title="वडा मा कार्यरत कर्मचारीहरुको लागि मात्र" placement="top">
                <TextField
                  label="कार्यरत वडा नं."
                  name="workingWardNumber"
                  type="number"
                  variant="outlined"
                  size="small"
                  inputRef={register}
                  fullWidth
                />
              </Tooltip>
            </Grid>
          </Grid>
          <Box item="true" textAlign="right" className={classes.btnContainer}>
            <Button
              type="reset"
              color="secondary"
              variant="contained"
              className={classes.resetBtn}
            >
              रद्द गर्नुहोस
            </Button>
            <Button type="submit" color="primary" variant="contained">
              खोज्नुहोस
            </Button>
          </Box>
        </form>
      </Paper>
      {searchResult &&
        <>
          <Box display={"flex"} justifyContent={"end"}>
            <Tooltip title="Excel डाउनलोड गर्नुहोस्।" placement="top" arrow>
              <CSVLink
                data={searchResult}
                headers={headers}
                filename="PIS-कर्मचारीहरु.csv"
                uFEFF={true}
                target="_blank"
              >
                <IconButton>
                  <GetApp />
                </IconButton>
              </CSVLink>
            </Tooltip>
          </Box>
          <StaffsList tableData={searchResult} postOptions={postOptions} search />
        </>}
    </Box>
  )
}
